// src/components/placement/PlacementResultView.jsx
import React from 'react';
import { Award, Download } from 'lucide-react';  // ✅ solo lo que se usa

export default function PlacementResultView({
  mode,
  finalLevel,
  skillScores,
  totalCorrect,
  totalQuestions,
  accuracy,
  onGoToDiploma,
  onExit,
  onSaveResult,
  totalTime,
  onStartMaster,
}) {
  const accuracyColor =
    accuracy >= 80 ? 'text-emerald-600' :
    accuracy >= 60 ? 'text-yellow-600'  :
                     'text-red-600';

  const levelEmoji = {
    A1: '🌱', A2: '🌿', B1: '🪴',
    B2: '🌳', C1: '🌲', C2: '🌍'
  }[finalLevel] || '📚';

  const recommendation = {
    A1: 'Empieza con Módulo 1 - Principiantes',
    A2: 'Continúa con Módulo 3 - Vas por buen camino',
    B1: 'Módulo 6 Sigue asi!',
    B2: 'Módulo 9 Es hora de pulir detalles',
    C1: 'Módulo 10 → Desafíos avanzados',
    C2: 'Master vocabulary and expressions',
  }[finalLevel] || 'Continúa practicando';

  // ✅ Formato seguro del tiempo
  const safeTime   = totalTime || 0;
  const timeMin    = Math.floor(safeTime / 60);
  const timeSec    = String(safeTime % 60).padStart(2, '0');

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-indigo-50 to-purple-50 flex flex-col items-center justify-center p-4 gap-6">

      {/* RESULTADO PRINCIPAL */}
      <div className="bg-white rounded-3xl shadow-2xl p-8 w-full max-w-md text-center border-4 border-emerald-100">
        <div className="text-6xl mb-4">{levelEmoji}</div>
        <h1 className="text-4xl font-black bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent mb-2">
          {finalLevel}
        </h1>
        <p className="text-sm text-slate-500 mb-4">Nivel CEFR</p>

        <div className="space-y-1 mb-4">
          <p className="text-2xl font-black">{totalCorrect}/{totalQuestions} correctas</p>
          <p className={`text-xl font-bold ${accuracyColor}`}>{accuracy}% de precisión</p>
        </div>

        {/* ✅ Tiempo con fallback */}
        <div className="text-xs text-slate-400 text-center">
          ⏱ Completaste el test en{' '}
          <span className="font-bold text-slate-600">
            {timeMin}:{timeSec} min
          </span>
        </div>
      </div>

      {/* RECOMENDACIÓN */}
      <div className="bg-white rounded-2xl shadow-lg p-6 w-full max-w-md border border-slate-100">
        <p className="text-xs font-black text-indigo-400 uppercase tracking-widest mb-3">
          Tu camino recomendado
        </p>
        <p className="text-sm text-slate-700">{recommendation}</p>
      </div>

      {/* % POR HABILIDAD — solo Master */}
      {mode === 'master' && (
        <div className="w-full max-w-md grid grid-cols-3 gap-3">
          {Object.entries(skillScores || {}).map(([skill, score]) => (  // ✅ fallback
            <div key={skill} className="bg-white rounded-xl p-4 text-center shadow-sm border">
              <p className="text-xs font-bold text-slate-500 uppercase tracking-wide mb-1">
                {skill}
              </p>
              <p className="text-2xl font-black text-indigo-600">{score}%</p>
            </div>
          ))}
        </div>
      )}

      {/* BOTONES */}
      <div className="w-full max-w-md space-y-2">
        <button
          onClick={() => onSaveResult?.({
            cefrLevel:    finalLevel,
            cefrAccuracy: accuracy,
            skillScores:  skillScores,  // ✅ ahora llega al diploma
          })}
          className="w-full bg-emerald-500 text-white py-4 rounded-2xl font-black text-lg shadow-xl shadow-emerald-200 hover:scale-[1.02] active:scale-[0.98] transition-all flex items-center justify-center gap-2 border-b-4 border-emerald-600"
        >
          <Award fill="currentColor" size={20} />
          Guardar mi nivel
        </button>

        {mode === 'placement' && (
          <button
            onClick={onStartMaster}
            className="w-full bg-purple-600 text-white py-3 rounded-2xl font-black shadow-lg shadow-purple-200 hover:scale-[1.02] transition-all flex items-center justify-center gap-2 border-b-4 border-purple-700"
          >
            🏆 Quiero el Diploma Master Challenge
          </button>
        )}

        {mode === 'master' && (
          <button
    onClick={() => onGoToDiploma({     
      cefrLevel:   finalLevel,
      skillScores: skillScores,
    })}
            className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-3 rounded-2xl font-black shadow-lg shadow-indigo-200 hover:scale-[1.02] transition-all flex items-center justify-center gap-2 border-b-4 border-indigo-700"
          >
            <Download size={18} />
            Descargar Diploma PDF
          </button>
        )}

        <button
          onClick={onExit}
          className="w-full bg-slate-100 text-slate-500 py-3 rounded-2xl font-black text-sm hover:bg-slate-200 transition-colors flex items-center justify-center gap-2"
        >
          ← Volver al inicio
        </button>
      </div>
    </div>
  );
}
